import React, { useEffect, useState } from "react";
import { PDFFILE_IMG, TOOLTIPICON } from "../../../utills/image-constant";
import DropDownWithLabel from "../../../admin/components/common/DropDownWithlable";
import RadioInput from "../../../admin/components/common/RadioInput";
import { addindividualResultRemark, dimensionCurrent, getAllAssignEmployeesByCampaignId, getAllCampaignByCompanyId, getAllCompanies, getAllEmployee, getAllEmployeesByCampaignId, getAllModelDimensionSubDimensionList, getindividualResult, subDimensionMaturityLineOverallVersusBenchmark } from "../../../services/api-services";
import TableHeading from "../../../admin/components/common/TableHeading";
import { toastEmitter } from "../../../utills/utilities";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MyDocument from "./PDFContent";
import { API_RESPONSE } from "../../../utills/app-constant";
import SearchDropDownWithLabel from "../../../admin/components/common/SearchDropdown";
import { useLocation } from "react-router-dom";

import Slider from "react-slick";
import SmallBarChart from "./SmallBarChart";
import MaturityScale from "./MaturityScale";
import SidebarAccordion from "./SidebarAccordion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const IndivisualResultNew = () => {
  const location = useLocation();
  const [companyList, setcompanyList] = useState([]);
  const [campainList, setcampainList] = useState([]);
  const [campainId, setcampainId] = useState();
  const [campainDisable, setcampainDisable] = useState(true);
  const [companyId, setcompanyId] = useState();
  const [companyName, setcompanyName] = useState("");
  const [employeeId, setemployeeId] = useState();
  const [employeeType, setemployeeType] = useState("online");
  const [employeeName, setemployeeName] = useState("");
  const [employeeList, setemployeeList] = useState([]);
  const [employeDisable, setemployeeDisable] = useState(true);
  const [showResult, setshowResult] = useState(false);
  const [showLoder, setshowLoader] = useState(true);
  const [questionAnswer, setquestionAnswer] = useState([]);
  const [remark, setRemark] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const [modelList, setmodelList] = useState([]);
  const [selectedSubId, setSelectedSubId] = useState('');
  const [avgLavel, setAvglevel] = useState({
    current: '',
    future: '',
    important: ''
  });
  let EmployeetData = location?.state?.Data
  console.log('activeTab', activeTab);

  useEffect(() => {
    if (EmployeetData) {
      setcompanyId(EmployeetData.companyId || "");
      setemployeeId(EmployeetData.id || "");
      setemployeeList([{
        value: EmployeetData.id,
        label: EmployeetData.employeeName,
        Status: EmployeetData.status,
        type: EmployeetData?.type?.toLowerCase(),

      }]);
    }
  }, []); // run only once
  const handleAnswerChange = (section, setSectionAnswer) => (e) => {
    setSectionAnswer(e.target.value);
  };

  // Get all companies and map them into options
  const getallCompany = async (status) => {
    try {
      const response = await getAllCompanies(status);
      if (response?.data?.responseCode === 404) {
        // Handle no companies if necessary
      } else if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody?.map((item) => ({
          value: item.id,
          label: item.companyName,
          Status: item.status,
        }));
        setcompanyList(companyOptions);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };



  useEffect(() => {
    getallCompany(1);
  }, []);



  const handleemployeSelect = async (selectedOption) => {
    setemployeeName(selectedOption?.label); // Get the label of the selected option
    setemployeeId(selectedOption?.value); // Set the ID

    setemployeeType(selectedOption?.type);
    // const payload = {
    //   "modelIdList": selectedOption?.modelId
    // };
    try {
      const response = await getAllModelDimensionSubDimensionList(selectedOption?.modelList);
      if (response?.data?.responseCode === 404) {
        // Handle no companies if necessary
      } else if (response?.data?.responseCode === 200) {
        const firstSubId = response?.data?.responseBody?.modelList[0].dimensionList[0].subDimensionList[0].id;
        console.log('firstSubId', firstSubId);


        setSelectedSubId(firstSubId);
        setmodelList(response?.data?.responseBody?.modelList);

      } else {
        toastEmitter("error", response?.data?.message);

      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);

    }
  };

  const handlecompanySelect = async (event) => {
    const { selectedOptions } = event.target;
    const label = selectedOptions[0]?.text; // Get the label of the selected option
    const companyId = event.target.value;
    setcampainId(null);
    setemployeeId(null);
    setemployeeName("");
    setemployeeList([]);
    setcampainList([]);
    setcampainDisable(true);
    setcompanyName(label);
    setcompanyId(companyId);
    setemployeeDisable(true);
    setshowResult(false);
    try {
      const response = await getAllCampaignByCompanyId(companyId);



      if (response?.data?.responseCode === 404) {
        toastEmitter("error", response?.data?.message);
      } else if (response?.data?.responseCode === 200) {

        const campainOptions = response?.data?.data?.map((item) => ({
          value: item.id,
          label: item.title,
          Status: item.status,
        }));

        setcampainList(campainOptions);
        setcampainDisable(false);
      } else {
        toastEmitter("error", response?.data?.message);
        setcampainDisable(true);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      setcampainDisable(true);
    }

  };

  const handleClick = async () => {
    setshowLoader(true);


    if (!companyId && !employeeId) {
      toastEmitter("error", "Both Organization and Employee are not selected.");
    } else if (!companyId) {
      toastEmitter("error", "Organization is not selected.");
    } else if (!employeeId) {
      toastEmitter("error", "Employee is not selected.");
    } else {
      setshowResult(true);
      try {

        const response = await getindividualResult(campainId, employeeId, selectedSubId, employeeType);


        if (response?.data?.responseCode === 200 || response?.data?.responseCode == "SUCCESS") {
          setshowLoader(false);
          const result = response?.data?.data;
          console.log('result----------------',result);
          
          setAvglevel({
            current: result?.currentAverageValue,
            future: result?.futureAverageValue,
            important: result?.setImportantAverageValue,
          });
          const modifiedQuestionAnswer = response?.data?.data?.questionResponseList?.map(question => {
            const optionValues = question.optionResponseList?.map(option => option.value);
            return {
              ...question,
              optionResponseList: optionValues, // replace the original optionResponseList with the transformed array
            };
          });
          setquestionAnswer(modifiedQuestionAnswer)
          setRemark(response?.data?.data?.remark)
        }
      } catch (err) {

      }
    }
  };


  const handleRemarkChange = (event) => {
    setRemark(event.target.value); // Update state with the new value
  };

  const validateRemark = async () => {
    if (!remark) {
      toastEmitter("error", "Please Enter Remark");
    } else {
      try {
        const updatedPayload = {
          employeeId: employeeId,
          remark: remark
        }
        const response = await addindividualResultRemark(employeeId, remark);
        if (response?.data?.responseCode === 200) {
          toastEmitter("success", response?.data?.message);
        } else {
          toastEmitter("error", response?.message);
        }
      } catch (err) {
        toastEmitter("error", API_RESPONSE.MESSAGE_503);
      }
    }
  };

  const [empPayload, setEmpPayload] = useState({
    pageIndex: 0,
    pageSize: 0,
    searchText: '',
    direction: 'desc',
    filterByFieldName: 'id',
    status: 1,
    campaignId: "",
  });

  const handlecampaignSelect = async (event) => {
    const campainId = event.value;
    setcampainId(campainId);
    setemployeeId(null);
    setemployeeName("");
    setemployeeList([]);
    setemployeeDisable(true);
    setcompanyId(companyId);
    const data = {
      ...empPayload,
      campaignId: campainId,
      pageIndex: 0,
      pageSize: 0,
      searchText: '', // ✅ FIXED — include search term here

    };
    try {

      const response = await getAllAssignEmployeesByCampaignId(data);


      if (response?.data?.responseCode === 200) {
        const employeeLists = response?.data?.responseBody?.map((item) => ({
          value: item?.employeeResponse?.id,
          label: item?.employeeResponse?.type?.toLowerCase() === 'assessor'
            ? `${item?.employeeResponse?.employeeName} (${item?.employeeResponse?.department} - ${item?.employeeResponse?.hierarchy})`
            : item?.employeeResponse?.employeeName,
          Status: item?.employeeResponse?.status,
          modelList: item?.employeeResponse?.modelId,
          type: item?.employeeResponse?.type?.toLowerCase(),
        }));
        setemployeeList(employeeLists);
        setemployeeDisable(false)
      }
    } catch (err) {
      setemployeeDisable(false)
    }
  };


  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(questionAnswer?.length || 1, 3),
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
  };


  const levels = [
    { number: 1, label: 'Initiating' },
    { number: 2, label: 'Emerging' },
    { number: 3, label: 'Performing' },
    { number: 4, label: 'Advancing' },
    { number: 5, label: 'Leading' },
  ];

  const handleSubDimensionClick = async (subdimenstionId) => {
    console.log('subdimenstionId', subdimenstionId);
    setSelectedSubId(subdimenstionId);
    // 👈 Save clicked sub ID
    setshowLoader(true);

  setComment('');
  setActiveTab('');
    if (!companyId && !employeeId) {
      toastEmitter("error", "Both Organization and Employee are not selected.");
    } else if (!companyId) {
      toastEmitter("error", "Organization is not selected.");
    } else if (!employeeId) {
      toastEmitter("error", "Employee is not selected.");
    } else {
      setshowResult(true);
      try {
        const response = await getindividualResult(campainId, employeeId, subdimenstionId, employeeType);
        console.log('response------------------------------------', response);

        if (response?.data?.responseCode === 200 || response?.data?.responseCode == "SUCCESS") {
          setshowLoader(false)
          const result = response?.data?.data;
          setAvglevel({
            current: result?.currentAverageValue,
            future: result?.futureAverageValue,
            important: result?.setImportantAverageValue,
          });
          const modifiedQuestionAnswer = response?.data?.data?.questionResponseList?.map(question => {
            const optionValues = question.optionResponseList?.map(option => option.value);
            return {
              ...question,
              optionResponseList: optionValues, // replace the original optionResponseList with the transformed array
            };
          });
          setquestionAnswer(modifiedQuestionAnswer)
          setRemark(response?.data?.data?.remark)
        }
      } catch (err) {

      }
    }


  };


  return (
    <div className="indivisual-result">
      <div className="indivisual-result-content">
        <div className="page-title">
          <h5 className="mb-3">Individual Result</h5>
        </div>
        <div className="indivisualresult_headsec">
          <div className="row">
            <div className="col-md-3">
              <DropDownWithLabel
                labelName="Select Organization"
                lableclassName="input-label"
                name="companyId"
                options={companyList}
                className="form-control inputText-lable"
                value={companyId}
                showastrict={true}
                handleSelect={handlecompanySelect}
              />
            </div>
            <div className="col-md-3">
              <SearchDropDownWithLabel
                key={companyId}
                disabled={campainDisable}
                labelName="Select Campaign"
                lableclassName="input-label"
                name="campainId"
                options={campainList}
                value={campainId}
                showastrict={true}
                className="form-control inputText-lable"
                handleSelect={handlecampaignSelect}
              />
            </div>
            <div className="col-md-4">
              <SearchDropDownWithLabel
                key={campainId}
                disabled={employeDisable}
                labelName="Select Employee"
                lableclassName="input-label"
                name="employeeId"
                options={employeeList}
                value={EmployeetData?.companyId ? EmployeetData?.companyId : employeeId || ""}
                showastrict={true}
                className="form-control inputText-lable"
                handleSelect={handleemployeSelect}
              />
            </div>

            <div className="col-md-2 d-flex justify-content-end">
              <div className="show-btnsec">
                <button onClick={handleClick} className="showbtn">Show Result</button>
              </div>
            </div>
          </div>
          {showResult ?
            <>

              <div className="row m-0">
                <div className="col-md-3">
                  <SidebarAccordion accordionItem={modelList} onSubDimensionClick={handleSubDimensionClick} selectedSubDimenstion={selectedSubId} />
                </div>
                <div className="col-md-9 p-0  ">



                  {showLoder ? <>
                    <div className="selectCompany mb-2">
                      <div className="loader-container">
                        <div className="loader"></div>
                      </div>
                    </div>
                  </> :
                    <>
                      {questionAnswer?.length > 0 ?
                        <><div className="row m-0">
                          <div className="col-md-12">
                            <div className="result_top_section">
                              <p>Customer / Customer Value with Revenue Optimization : Overall View</p>
                              <div className="row">
                                <div className="col-md-3 text-center">
                                  <SmallBarChart value={avgLavel.important} maturityScales={false} lavel={avgLavel} />
                                </div>
                                <div className="col-md-9">
                                  <MaturityScale currentLevel={avgLavel.current} targetLevel={avgLavel.future} optionLabel={true} importantLevel={avgLavel.important} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                          <div className="row m-0">
                            <div className="col-md-12">
                              <div className="slider_section">

                                <Slider {...settings}>
                                  {
                                    questionAnswer.map((item, index) => {
                                      const lavel = {
                                        current: item.current,
                                        future: item.future,
                                        important: item.important
                                      };

                                      return (
                                        <div className="question_box" key={index}>
                                          <div className="description_box">
                                            <div className="description_box_inner">
                                              {index + 1}) {item.question}
                                            </div>
                                          </div>
                                          <div className="answer_box">
                                            <div className="answer_box_bar">
                                              <SmallBarChart value={item.importantAvg} maturityScale={true} lavel={lavel} />
                                            </div>
                                          </div>
                                          <div className="answer_button_box">
                                            <button
                                              onClick={() => {
                                                setComment(item?.comment);
                                                setActiveTab(index);
                                              }}
                                              className={activeTab === index ? "activeComment" : ""}
                                            >View Comment
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })
                                  }


                                </Slider>
                                {activeTab !== '' && activeTab !== '' && (
                                  <div className="comment_area">
                                    {comment || "No comment"}
                                  </div>
                                )}
                              </div>

                            </div>
                          </div>

                        </> : <div className="selectCompany mb-2">
                          <TableHeading
                            firstData="Not Record Found"
                            TableHeading="mb-0"
                            secondclassName='textcolor'
                            className='textcolor'

                          />
                        </div>}

                    </>
                  }

                </div>
              </div>
            </> :
            <>
              <div className="selectCompany mb-2">
                <TableHeading
                  firstData="Please click the 'Show Result' button to view the employee's result. "
                  TableHeading="mb-0"
                  secondclassName='textcolor'
                  className='textcolor'

                />
              </div>
            </>}
          <br />

        </div>
      </div>
    </div>
  );
};

export default IndivisualResultNew;
